<template>
    <div class="ui-404-body">
        <img src="../../../public/images/404.png">
        <p class="title">Sorry</p>
        <p>您访问的页面不存在~~~~</p>
        <router-link to="/manage/index">
            <el-button type="primary">返回首页</el-button>
        </router-link>
    </div>
</template>

<script>
    export default {
        name: "404",
        data() {
            return {};
        },
        // 监听属性
        computed: {},
        // 监控data中的数据变化
        watch: {},
        // 方法集合
        methods: {},
        // 生命周期 - 创建之前
        beforeCreate() {
        },
        // 生命周期 - 创建完成
        created() {
        },
        // 生命周期 - 挂载之前
        beforeMount() {
        },
        // 生命周期 - 挂载完成
        mounted() {
        },
        // 生命周期 - 更新之前
        beforeUpdate() {
        },
        // 生命周期 - 更新之后
        updated() {
        },
    }
</script>
<style scoped>
    .ui-404-body {
        height: 100%;
        text-align: center;
        background-color: #f7f8f9;
    }

    .ui-404-body img {
        width: 30%;
    }

    .ui-404-body p {
        font-size: 32px;
        margin-bottom: 5%;
    }

    .ui-404-body p.title {
        font-style: oblique;
        color: #0291ff;
        font-size: 82px;
        font-weight: bold;
        margin-top: -1%;
        margin-bottom: 1.5%;
    }

    .ui-404-body a {
        display: block;
    }

    .ui-404-body a .el-button {
        width: 20%;
    }
</style>
